import {CURRENCY} from "../../common/constant";

const CurrencyReducer = (state, action) => {
    const newState = {
        currency: undefined,
        currencyName: "",
        currencies: {},
        currencyNames: {},
        localesMap: {}
    };

    switch (action.type) {
        case "INIT_CURRENCY":
            action.payload.currencySelectionCollection.forEach((item) => {
                newState.currencies[item.name] = item.name;
                if (item.locale) {
                    newState.localesMap[item.locale] = item.name;
                }
                newState.currencyNames[item.name] = item.title;
            });
            if (action.payload.currencyFromLocalStorage && newState.currencies[action.payload.currencyFromLocalStorage]){
                newState.currency = action.payload.currencyFromLocalStorage;
                newState.currencyName = newState.currencyNames[action.payload.currencyFromLocalStorage];
            } else {
                // Get currency based on locale, defaults to EUR
                newState.currency = newState.currencies[newState.localesMap[action.payload.localeUppercaseUnderscore] || "EUR"];
                window.localStorage.setItem(CURRENCY, JSON.stringify(newState.currency));
            }
            return {
                ...state,
                currency: newState.currency,
                currencyName: newState.currencyName,
                currencyNames: newState.currencyNames,
                currencies: newState.currencies,
                localesMap: newState.localesMap
            };
        case "SET_CURRENCY":
            window.localStorage.setItem(CURRENCY, JSON.stringify(action.payload));
            return {
                ...state,
                currency: action?.payload,
                currencyName: state?.currencyNames[action?.payload]
            };
        default:
            return state;
    }
};

export default CurrencyReducer;
